// extracted by mini-css-extract-plugin
module.exports = {"root":"EditSocialAmenitiesPanel_root__MXZN6","form":"EditSocialAmenitiesPanel_form__3wUFK","title":"EditSocialAmenitiesPanel_title__19gfn"};